<template>
  <v-container grid-list-sm class="kp-tasks-page" :style="width">
    <v-progress-linear
      style="z-index: 6"
      color="warning"
      indeterminate
      rounded
      height="3"
      fixed
      top
      v-if="isBusy || loading"
    ></v-progress-linear>
    <div
      v-if="session.alert"
      class="kp-tasks-page__alert mb-4"
    >
      <v-alert
        color="primary"
        dismissible
        outlined
        :value="true"
      >
        <div class="text-h4">
          KP Instructions
        </div>
        <span v-html="session['alert']"></span>
      </v-alert>
      <v-btn
        v-if="isSuperAdmin || isVIP"
        class="kp-tasks-page__edit mx-0"
        icon
        @click="$refs.editSessionModal.toggle(selectedClient, session)"
      >
        <v-icon size="18" color="primary">edit</v-icon>
      </v-btn>
    </div>
    <v-expansion-panels
      :readonly="formChanged"
      v-model="panel"
      focusable
      :popout="isDesktop || isDevice"
    >
      <v-expansion-panel
        v-for="(legislator, index) in legislators"
        :key="legislator.id"
        :value="legislator.id"
      >
      <v-expansion-panel-header
        v-if="legislator.tasks.length > 0 && legislators.length > 0 || !legislator.kp1"
        disable-icon-rotate
        class="pa-2"
        @click="openAlert(index)"
      >
        <div class="kp-tasks-page_legislator">
          <v-avatar color="grey" size="62" class="kp-tasks-page_legislator__avatar mr-3">
            <img :src="getThumbImageMedium(legislator.official_image)">
          </v-avatar>
          <vip-chip
            v-if="legislator.vip"
            class="kp-tasks-page_legislator__vip"
            :legislator="legislator"
            :show="'badge_code'"
          ></vip-chip>
          <div class="d-flex flex-wrap">
            <span class="kp-tasks-page_legislator__name">{{ legislator.salutation }}</span>
            <span class="Caption kp-tasks-page_legislator__under-string" v-if="legislator.primary_kp.kp_position == 1">
              You are KP{{ legislator.primary_kp.kp_position }}
            </span>
            <span class="Caption kp-tasks-page_legislator__under-string" v-else-if="legislator.kp1">
              You are KP{{ legislator.primary_kp.kp_position }}, {{legislator.kp1.fullname}} is KP1
            </span>
            <span class="Caption kp-tasks-page_legislator__under-string" v-else>
              You are KP{{ legislator.primary_kp.kp_position }}, KP1 not assigned
            </span>
          </div>
          <v-tooltip bottom v-if="legislator.lame_duck">
            <template v-slot:activator="{ on }">
              <a v-on="on">
                <v-icon color="#EECB23" size="18" class="mx-2">fa-solid fa-duck</v-icon>
              </a>
            </template>
            <span>Lame Duck</span>
          </v-tooltip>
        </div>
        <div
            v-if="(panel == index && formChanged) || (panel == index && noteChanged)"
            class="kp-tasks-page_save-buttons"
          >
            <v-btn outlined color='secondary' @click.native.stop="refresh" :x-small="isMobile" class="ma-1">Cancel
            </v-btn>
            <v-btn
              v-if="isMobile"
              class="warning ma-1"
              :disabled="isBusy"
              @click.native.stop="onSave(legislator, index)"
              small
            >
              <x-small>Save<br />when done</x-small>
            </v-btn>
            <v-btn
              v-if="isDesktop || isDevice"
              class="ma-1"
              :disabled="isBusy"
              color="primary"
              @click.native.stop="onSave(legislator, index)"
            >
              Save when done
            </v-btn>
          </div>
          <template v-slot:actions>
  <!-- When there are no tasks at all -->
  <v-chip
    v-if="getTotalTasksCount(legislator) === 0"
    small
    label
    color="primary"
    class="pa-1"
    :key="`no-tasks-${legislator.id}`"
  >
    No Current Tasks
  </v-chip>
  
  <!-- When all tasks are completed and there are at least 1 task -->
  <v-chip
    v-else-if="successAllTasks(legislator) && getTotalTasksCount(legislator) > 0"
    small
    label
    color="success"
    class="pa-1"
    :key="`complete-${legislator.id}`"
  >
    Current Tasks Completed
  </v-chip>
  
  <!-- When there are tasks but not all are completed -->
  <v-chip
    v-else
    small
    label
    outlined
    :color="getTasksDeadlineStatus(legislator) || 'primary'"
    class="pa-1"
    :key="`progress-${legislator.id}-${getCompletedTasksCount(legislator)}`"
  >
    {{ getCompletedTasksCount(legislator) }}/{{ getTotalTasksCount(legislator) }} Completed
  </v-chip>
</template>
      </v-expansion-panel-header>
        <v-expansion-panel-content>
          <my-tasks-tag
            ref="myTasksTag"
            :legislator="legislator"
            :member="member"
            @handleFormChange="handleFormChange"
            @handleNoteChange="handleNoteChange($event)"
            @updatingTaskResult="updatingTaskResult($event)"
            @refresh="refresh"
          ></my-tasks-tag>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-layout row class="kp-tasks-page_actions">
      <v-flex xs12 sm4>
        <v-btn block class="mt-2" :disabled="loading" @click="dialogArticle = true" color="primary">
          <v-icon left>
            fa-light fa-folders
          </v-icon>
          KP Resources
          <v-badge
            v-if="latestArticle && getBadge(latestArticle) == 'New'"
            inline
            color="green"
            class="mt-0"
            style="flex:unset;"
          >
            <template v-slot:badge>
              <span>New</span>
            </template>
          </v-badge>
          <v-badge
            v-if="latestArticle && getBadge(latestArticle) == 'Updated'"
            inline
            color="green"
            class="mt-0"
            style="flex:unset;"
          >
            <template v-slot:badge>
              <span>Updated</span>
            </template>
          </v-badge>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-btn block class="mt-2" :disabled="loading" @click="openSendMessageModal" color="primary">
          <v-icon left>
            fa-light fa-comment-question
          </v-icon>
          Ask for Help
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-tooltip bottom :disabled="editProfileBtnTooltipMessage.length === 0">
          <template v-slot:activator="{ on, attrs }">
            <v-badge
            bordered
            color="error"
            icon="mdi-exclamation"
            overlap
            :value="editProfileBtnTooltipMessage.length"
            class="mt-2 w-full d-block"
            >
              <v-btn v-bind="attrs" v-on="on" block @click="openProfileEditModal" color="primary">
                <v-icon left>
                  fa-light fa-user-pen
                </v-icon>
                My Profile
              </v-btn>
            </v-badge>
          </template>
          <span>
            <!-- Missing avatar and/or cell phone -->
            {{ editProfileBtnTooltipMessage }}
          </span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-if="legislators.length > 0 && dialogSnackbar"
      v-model="dialogSnackbar"
      color="error"
      top
      :timeout="2000"
    >
      <div>
        <span>
          Please Save or Cancel current changes for
          {{
            legislators && legislators[panel].fullname
              ? legislators[panel].fullname
              : 'legislator'
          }}
          before moving on to another legislator
        </span>
        <v-btn
          text
          @click="dialogSnackbar = false"
        >
          OK
        </v-btn>
      </div>

    </v-snackbar>
<!--
    <v-container max-width="600px" class="py-5">
    <v-card v-if="coordinator && coordinator.nickname" elevation="2">
      <v-card-title>
        Your Regional Coordinator:
      </v-card-title>
      <v-card-text>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6 font-weight-bold">
                {{ coordinator.nickname }} {{ coordinator.lastname }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">fa-light fa-envelope</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <a :href="`mailto:${coordinator.email}`">{{ coordinator.email }}</a>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <a :href="`tel:${coordinator.cell}`" class="mr-3">
                  <v-icon color="primary">fa-light fa-phone</v-icon>
                </a>
                <a :href="`sms:+${coordinator.cell}`" class="mr-3">
                  <v-icon color="primary">fa-light fa-comment-sms</v-icon>
                </a>
                  <span>{{ coordinator.cell }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
  -->
    <v-dialog v-model="dialogArticle" :fullscreen="isMobile">
      <articles-index
        :dialog="dialogArticle"
        @closeModal="closeArticleModal"
      ></articles-index>
    </v-dialog>
    <send-message-modal ref="SendMessageModal"></send-message-modal>
    <kp-profile-edit-modal ref="kpProfileEditModal"></kp-profile-edit-modal>
    <edit-session-modal
      ref="editSessionModal"
      :active-session="session"
      :session-list="sessionList"
      :committee-list="committeeList"
      :refresh="refresh"
    ></edit-session-modal>
  
  <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      color="success"
      bottom
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MemberService from '@/services/MemberService'
import StateService from '@/services/StateService'
import ResourcesService from '@/services/ResourcesService'
import ClientService from "@/services/ClientService";

import filterCommitteeList from '@/mixins/filterCommitteeList'

import KpProfileEditModal from '@/components/members/kp-profile-edit-modal'
import MyTasksTag from '@/components/my-tasks/my-tasks-tag';
import editSessionModal from '@/components/sessions/edit-session-modal'
import ArticlesIndex from '@/components/articles/articles-index';
import SendMessageModal from '@/components/my-tasks/send-message-modal';
import TaskService from "@/services/TaskService";
import VipChip from "@/components/legislators/vip-setting/vip-chip";
import {mapGetters, mapState} from "vuex";

export default {
  name: 'KpTasksComponent',
  mixins: [MemberService, ResourcesService, ClientService, filterCommitteeList, StateService, TaskService],
  components: {
    'edit-session-modal': editSessionModal,
    'my-tasks-tag' : MyTasksTag,
    'articles-index': ArticlesIndex,
    'send-message-modal': SendMessageModal,
    'vip-chip': VipChip,
    'kp-profile-edit-modal': KpProfileEditModal,
  },
  props: {
    member: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      legislators: [],
      isBusy: false,
      loading: false,
      dialog: false,
      session: {},
      taskResult: 0,
      dialogArticle: false,
      sessionList: [],
      tab: null,
      currentTab: null,
      formChanged: false,
      noteChanged: false,
      panel: null,
      dialogSnackbar: false,
      newNote: {},
      coordinator: {}
    }
  },
  mounted() {
    this.refresh()
    if (!this.isSuperAdmin) {
      this.getArticles()
    }
  },
  computed: {
    ...mapState('kpProfile', [
      'kpPortalLoggedMember'
    ]),
    editProfileBtnTooltipMessage(){
      if(!this.isKP || this.isProfileUpdate || !this.selectedClient){
        return ''
      }

      const missingColumns = [];

      if(this.kpPortalLoggedMember && !this.kpPortalLoggedMember.avatar_url){
        missingColumns.push('avatar')
      }
      
      if(this.kpPortalLoggedMember && !this.kpPortalLoggedMember.cell){
        missingColumns.push('cell')
      }

      if(missingColumns.length === 0){
        return ''
      }

      let message = 'Missing ';

      message += missingColumns.join(', ')

      message += ' information'
      return message;
    },
    isProfileUpdate(){
      return localStorage.getItem('onlyProfileUpdate')
    },
    width() {
      if (this.isFullScreen) {
        return 'width:80%'
      }
      return this.isDesktop || this.isDevice 
        ? 'width:60%; max-width:1000px' 
        : 'width:100%'
      },
    alertMessage() {
      return 'These are your legislator(s) for which you are the primary KP. ' +
        'Please learn about them, complete assigned tasks by deadlines, ' +
        'record any donations, and keep us updated with Notes. Thanks!'
    },
    ...mapGetters('app', ['superAdminSelectedClient']),
    selectedClient() {
        return this.isSuperAdmin ? this.superAdminSelectedClient : this.userClient
    },
    isFederalClient(){
      return this.selectedClient && this.selectedClient.is_use_state === 0;
    },
    memberId() {
      return this.member && this.member.id ? this.member.id : this.userMemberId
    },
    client() {
      return this.isSuperAdmin ? this.superAdminSelectedClient : this.userClient
    },
  },
  methods: {
    getTasksDeadlineStatus(legislator) {
  // Check if there are any tasks with expired or approaching deadlines
  const tasksWithDeadlines = legislator.tasks.filter(task => {
    return task.task_type.data_type !== 'Notes' && task.task_type.data_type !== 'Currency' && task.deadline
  });
  
  // If no tasks with deadlines, return null (use default color)
  if (tasksWithDeadlines.length === 0) return null;
  
  // Check if any task has an "error" deadline (less than 7 days)
  const hasErrorDeadline = tasksWithDeadlines.some(task => {
    const remainingDays = moment.duration(moment(task.deadline).diff(moment())).asDays();
    return remainingDays <= 7 && !task.result;
  });
  
  // Check if any task has a "warning" deadline (less than 28 days)
  const hasWarningDeadline = tasksWithDeadlines.some(task => {
    const remainingDays = moment.duration(moment(task.deadline).diff(moment())).asDays();
    return remainingDays > 7 && remainingDays <= 28 && !task.result;
  });
  
  if (hasErrorDeadline) return 'error';
  if (hasWarningDeadline) return 'warning';
  return null; // Use default color
},
    getCompletedTasksCount(legislator) {
      const taskWithoutNotes = legislator.tasks.filter(task => {
        return task.task_type.data_type !== 'Notes' && task.task_type.data_type !== 'Currency'
      })
      return taskWithoutNotes.filter(task => task.result).length;
    },

    getTotalTasksCount(legislator) {
      return legislator.tasks.filter(task => {
        return task.task_type.data_type !== 'Notes' && task.task_type.data_type !== 'Currency'
      }).length;
    },
    openProfileEditModal() {
      // First, make sure the modal component is fully mounted
      this.$nextTick(() => {
        if (this.$refs.kpProfileEditModal) {
          // Set the modal to open
          this.$refs.kpProfileEditModal.isModalOpen = true;
      
          // Add a small delay to ensure the modal has time to fully initialize
          setTimeout(() => {
            // Force a refresh of the member data to load custom fields
            if (this.$refs.kpProfileEditModal && typeof this.$refs.kpProfileEditModal.getMember === 'function') {
              this.$refs.kpProfileEditModal.getClientCustomFields();
              this.$refs.kpProfileEditModal.getMember();
              this.$refs.kpProfileEditModal.getInterestsList();
              this.$refs.kpProfileEditModal.getUniversity();
              this.$refs.kpProfileEditModal.getPoliticalLeaningsList();
              this.$refs.kpProfileEditModal.refreshDistrict();
              this.$refs.kpProfileEditModal.updateDistricts();
            }
          }, 500); // 500ms delay
        }
      });
    },
    openSendMessageModal() {
      // Get the current legislator ID (from the selected panel)
      const currentLegislatorId = this.panel !== null && this.legislators && this.legislators[this.panel] 
        ? this.legislators[this.panel].id 
        : null;
      // Pass it to the modal
      this.$refs.SendMessageModal.openModal(currentLegislatorId);
    },
    open() {
    this.isModalOpen = true;
    },
    openAlert(index) {
      if (this.formChanged && index !== this.panel) {
        this.dialogSnackbar = true;
      }
    },
    openOnlyOnePanel() {
      let indexLegislator = 0;
      let legislatorsWithTasks = this.legislators.filter((legislator,index) => {
        if (legislator.tasks.length > 0) { indexLegislator = index }
        return legislator.tasks.length > 0
      })
      if (legislatorsWithTasks.length === 1) {
        this.panel = indexLegislator
      }
    },
    updatingTaskResult(taskResultId)
    {
      this.taskResult = taskResultId
    },
    closeArticleModal() {
      this.dialogArticle = false;
    },
    successAllTasks(legislator) {
      let taskWithoutNotes = legislator.tasks.filter(tasks => {
        return tasks.task_type.data_type !== 'Notes' && tasks.task_type.data_type !== 'Currency'
      })

      let countTask = taskWithoutNotes.length
      let countResults = taskWithoutNotes.filter(task => { return task.result }).length

      return countTask === countResults
    },
    titleTask(legislator) {
      const reg = /^[HS]/;
      let district = legislator.district.district.match(reg)
      let titleTask = ''
      if (district && district[0] === 'H' || (this.isFederalClient && this.selectedClient.formal_house)) {
        titleTask = `${this.selectedClient.formal_house} ${legislator.fullname}`
      } else if (district && district[0] === 'S') {
        titleTask = `${this.selectedClient.formal_senate} ${legislator.fullname}`
      } else {
        titleTask = `${legislator.fullname}`
      }
      return titleTask
    },
    async refresh() {
      this.loading = true
      this.taskResult = 0
      this.coordinator = {}
      try {
        await this.filterCommitteeList()
        this.sessionList = (await this.getClientSessions(this.selectedClient.id)).data
        let result = (await this.getKPTasks(this.memberId)).data
        this.session = (await this.getClientActiveSession(this.selectedClient.id)).data
        if(!this.session) this.session = {}
        this.formChanged = false
        this.noteChanged = false
        this.loading = false
        this.legislators = result.map((legislator) => {
          let primaryKp = Array.isArray(legislator.member_legislators)
            ? legislator.member_legislators.filter(
                (memberLegislator) =>
                  memberLegislator.member_id === this.memberId
              )
            : [];

          let kp1 = Array.isArray(legislator.member_legislators)
            ? legislator.member_legislators.filter(
                (memberLegislator) => memberLegislator.kp_position == 1 && memberLegislator.member_id === this.memberId
              )
            : [];
            
          primaryKp = primaryKp && primaryKp.length ? primaryKp[0] : { session_tasks: [] };

          // If the primary KP is not KP1 and the "CC All" flag is set,
          // assign session tasks from KP1 to the primary KP.
          // This ensures consistency by copying KP1's session tasks to others when needed.
          let legAnotherKp1 = Array.isArray(legislator.member_legislators)
            ? legislator.member_legislators.filter((memberLegislator) => memberLegislator.kp_position == 1)
            : [];

          if (primaryKp && primaryKp.send_copy && primaryKp.kp_position !== 1) {
            primaryKp.session_tasks = legAnotherKp1[0].session_tasks;
          }

          return {
            ...legislator,
            kp1: kp1 && kp1[0] && kp1[0].member,
            salutation: this.titleTask(legislator),
            primary_kp: primaryKp,
            tasks: primaryKp.session_tasks && primaryKp.session_tasks.length ? primaryKp.session_tasks.map((task) => ({
              ...task,
              result:
                task.task_results ? task.task_results.filter(
                  (taskResult) => taskResult.legislator_id == legislator.id
                )[0] : null,
            })) : [],
          };
        });
        if(this.legislators.length > 0 ){
          this.coordinator = (await this.getCoordinatorOfLegislator(this.legislators[0].id)).data
        }
        this.openOnlyOnePanel()
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    handleFormChange() {
      this.formChanged = true
    },
    handleNoteChange(task) {
      this.newNote = task.result
      this.noteChanged = true
    },
    editTaskResult() {
      const payload = {
        result: this.newNote.result,
      }

      this.updateTaskResult(payload, this.taskResult)
        .then(() => {
          this.formChanged = false
          this.noteChanged = false
          this.newNote = {}
          this.$refs.myTasksTag.forEach(tag => {
            tag.clearNoteField()
          })
          this.isBusy = false
        })
        .catch((err) => {
          this.isBusy = false
          this.handleError(err, true)
        })

    },
    async onSave(legislator, index) {
      this.isBusy = true
      let results = []
      if (this.taskResult > 0) {
        await this.editTaskResult()
      }

      if (this.newNote && this.newNote.result && this.newNote.result.length && this.taskResult === 0) {
          results = [...this.getTasksWithoutNotes(legislator), {...this.newNote}]
      } else {
        results = this.getTasksWithoutNotes(legislator)
      }

      const payload = {
        legislator_id: legislator.id,
        results: results,
        id: this.memberId
      }

      this.addKPTaskResults(payload)
        .then(() => {
          this.formChanged = false
          this.noteChanged = false
          this.$refs.myTasksTag.forEach(tag => {
            tag.clearNoteField()
          })
          this.onCallToastr('success', `Success! Task Saved for ${legislator && legislator.fullname ? legislator.fullname : 'legislator'}`, 'Success!')
          this.refresh()
          this.isBusy = false
        })
        .catch((err) => {
          this.isBusy = false
          this.handleError(err, true)
        })
    },
    getTasksWithoutNotes(legislator) {
     return legislator.tasks.filter( task => task.name !== 'Notes' && task.result).map(task => {
         return {
           task_id: task.id,
           result: task.result.result
         }
      })
    }
  }
}
</script>